import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const dialogExitDuration = theme.transitions.short;

export const addedDuration = 1000;
